<template>
  <v-app style="background: black">
    <div v-if="authState != 'signedin'">
      <app-header
        v-if="!isPublicRoute"
        @signIn="
          () => {
            signInClicked = true;
            authStateType = authStateTypeSignIn;
          }
        "
        @signUp="
          () => {
            signInClicked = true;
            authStateType = authStateTypeSignUp;
          }
        "
      ></app-header>
      <app-public-header
        v-else
        @signIn="handlePublicSignIn"
        @signUp="handlePublicSignUp"
      ></app-public-header>
    </div>
    <div v-if="authState === 'signedin' && user">
      <app-signed-in-header
        @goHome="
          () => {
            goHomeClicked = !goHomeClicked;
          }
        "
        @toggleMap="toggleMap"
        @toggleBadge="toggleBadge"
        :user="user"
        :email="email"
      ></app-signed-in-header>
    </div>

    <v-main>
      <router-view
        :goHomeClicked="goHomeClicked"
        :user="user"
        :email="email"
        :toggleMapClicked="toggleMapClicked"
        :toggleBadgeClicked="toggleBadgeClicked"
      ></router-view>
      <div class="auth">
        <div v-if="authState != 'signedin' && !isPublicRoute">
          <v-card v-if="signInClicked" flat tile>
            <amplify-auth-container>
              <amplify-authenticator
                username-alias="email"
                :initial-auth-state="authStateType"
              >
                <amplify-sign-up
                  header-text="Sign Up for Free"
                  slot="sign-up"
                  username-alias="email"
                  :form-fields.prop="formFields"
                ></amplify-sign-up>
                <amplify-sign-in
                  header-text="Haikubox Sign In"
                  slot="sign-in"
                  :form-fields.prop="signInFields"
                ></amplify-sign-in>
              </amplify-authenticator>
            </amplify-auth-container>
            <v-card-subtitle
              >By continuing, I agree to the Haikubox Terms of Service.
            </v-card-subtitle>

            <router-link
              style="text-decoration: none; color: inherit"
              to="/terms"
            >
              <v-btn>Terms </v-btn>
            </router-link>

            <router-link
              style="text-decoration: none; color: inherit"
              to="/privacy"
            >
              <v-btn>Privacy Policy </v-btn>
            </router-link>
          </v-card>
          <v-img
            height="200px"
            src="https://haikubox-images.s3.amazonaws.com/web/partnerssm.jpeg"
          ></v-img>
        </div>
      </div>
      <div v-if="authState != 'signedin' && !isPublicRoute">
        <v-icon small color="white">mdi-copyright</v-icon
        ><span class="white--text font-weight-light"
          >2024 Loggerhead Instruments, Inc</span
        >
      </div>
      <div v-if="authState === 'signedin' && user">
        <!-- <app-footer></app-footer> -->
        <router-link style="text-decoration: none; color: inherit" to="/">
          <amplify-sign-out></amplify-sign-out>
        </router-link>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { Auth } from "aws-amplify";
import { AuthState, onAuthUIStateChange } from "@aws-amplify/ui-components";
import Header from "./components/Header.vue";
// import Footer from "./components/Footer.vue";
import HeaderSignedIn from "./components/HeaderSignedIn.vue";
import PublicHeader from "./components/PublicHeader.vue";
// import Landing from "./components/Landing.vue";
// import Privacy from "./components/Privacy.vue";
// import Terms from "./components/Terms.vue";
// import Haikumarine from "./Haikumarine.vue"

export default {
  beforeCreate() {
    // console.log('App.vue beforeCreate');
    onAuthUIStateChange((authState, authData) => {
      // console.log('onAuthUIStateChange', authState, authData, this.$route.path);
      this.authState = authState;
      if (authData != undefined) {
        // console.log(authData);
        this.user = authData.username;
        this.email = authData.attributes.email;
        // console.log('user', this.user);
        if (this.$route.path === "/") this.$router.push({ path: "/haikubox" });
      } else {
        this.user = "";
        this.email = "";
        // Only redirect to landing if not on a public route
        if (
          !this.isPublicRoute &&
          (this.$route.path !== "/") &
          (this.$route.path !== "/settings") &
          (this.$route.path !== "/privacy") &
          (this.$route.path !== "/terms") &
          (this.$route.path !== "/success")
        ) {
          this.$router.push({ path: "/" });
          // console.log("go to landing");
        }
      }
    });
  },
created() {
  if (this.authState === undefined) {
    Auth.currentAuthenticatedUser().then((authData) => {
      this.authState = AuthState.SignedIn;
      this.user = authData.username;
      this.email = authData.attributes.email;
      // console.log('created, signed in');
      
      // If user is authenticated and on the root path, redirect to /haikubox
      if (this.$route.path === "/" || this.$route.path === "") {
        this.$router.push({ path: "/haikubox" });
      }
    }).catch(() => {
      // User is not authenticated, but that's okay for public routes
      this.authState = AuthState.SignedOut;
    });
  }
},
  mounted() {
    // Add password visibility toggle functionality after component mounts
    this.addPasswordToggleButtons();
  },
  components: {
    appHeader: Header,
    // appFooter: Footer,
    appSignedInHeader: HeaderSignedIn,
    appPublicHeader: PublicHeader,
    // appLanding: Landing,
    // appPrivacy: Privacy,
    // appTerms: Terms,
    // appHaikumarine: Haikumarine,
  },
  beforeDestroy() {
    return onAuthUIStateChange;
  },
  data() {
    return {
      goHomeClicked: false,
      toggleMapClicked: false,
      toggleBadgeClicked: false,
      user: "",
      email: "",
      authState: undefined,
      authStateType: "signin",
      authStateTypeSignIn: "signin",
      authStateTypeSignUp: "signup",
      signInClicked: false, // Changed from true to false
      showMarineClicked: false,
      signInFields: [
        {
          type: "email",
          label: "Email Address",
          placeholder: "Enter your email",
          required: true,
          handleInputChange: (event, cb) => {
            document
              .querySelector("amplify-sign-in")
              .shadowRoot.querySelector("amplify-input input").value = document
              .querySelector("amplify-sign-in")
              .shadowRoot.querySelector("amplify-input input")
              .value.toLowerCase();
            cb(event);
          },
        },
        {
          type: "password",
          label: "Password",
          placeholder: "Enter password",
          required: true,
        },
      ],
      formFields: [
        {
          type: "email",
          label: "Email Address",
          placeholder: "Enter your email address",
          required: true,
          handleInputChange: (event, cb) => {
            document
              .querySelector("amplify-sign-up")
              .shadowRoot.querySelector("amplify-input input").value = document
              .querySelector("amplify-sign-up")
              .shadowRoot.querySelector("amplify-input input")
              .value.toLowerCase();
            cb(event);
          },
        },
        {
          type: "password",
          label: "Password",
          placeholder: "Enter password (>7 characters)",
          required: true,
        },
      ],
    };
  },
  computed: {
    isPublicRoute() {
      // Check if current route is a public group dashboard route
      const path = this.$route.path;
      return path.startsWith('/groups/') && path !== '/groups';
    }
  },
  watch: {
    signInClicked(newVal) {
      if (newVal) {
        // Wait for DOM update then add toggle buttons
        this.$nextTick(() => {
          setTimeout(() => {
            this.addPasswordToggleButtons();
          }, 500);
        });
      }
    }
  },
  methods: {
    toggleMap() {
      this.toggleMapClicked = !this.toggleMapClicked;
      // console.log("App toggle map", this.toggleMapClicked);
    },
    toggleBadge() {
      this.toggleBadgeClicked = !this.toggleBadgeClicked;
      // console.log("App toggle map", this.toggleMapClicked);
    },
    handlePublicSignIn() {
      // Navigate to home page and show sign in
      this.$router.push('/').then(() => {
        this.signInClicked = true;
        this.authStateType = this.authStateTypeSignIn;
      });
    },
    handlePublicSignUp() {
      // Navigate to home page and show sign up
      this.$router.push('/').then(() => {
        this.signInClicked = true;
        this.authStateType = this.authStateTypeSignUp;
      });
    },
    addPasswordToggleButtons() {
      // Function to add toggle to a specific password field
      const addToggleToField = (passwordInput, container) => {
        // Check if toggle already exists
        if (container.querySelector('.password-toggle-btn')) return;
        
        // Create wrapper to position the toggle button
        const wrapper = document.createElement('div');
        wrapper.style.position = 'relative';
        
        // Wrap the input
        passwordInput.parentNode.insertBefore(wrapper, passwordInput);
        wrapper.appendChild(passwordInput);
        
        // Create toggle button
        const toggleBtn = document.createElement('button');
        toggleBtn.className = 'password-toggle-btn';
        toggleBtn.type = 'button';
        toggleBtn.style.cssText = `
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          border: none;
          background: none;
          cursor: pointer;
          padding: 5px;
          color: #999;
          z-index: 10;
        `;
        
        // Set initial icon (eye icon)
        toggleBtn.innerHTML = `
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
            <circle cx="12" cy="12" r="3"></circle>
          </svg>
        `;
        
        // Add padding to input to make room for button
        passwordInput.style.paddingRight = '40px';
        
        // Toggle functionality
        toggleBtn.addEventListener('click', () => {
          const isPassword = passwordInput.type === 'password';
          passwordInput.type = isPassword ? 'text' : 'password';
          
          // Update icon
          if (isPassword) {
            // Show eye-off icon
            toggleBtn.innerHTML = `
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
            `;
          } else {
            // Show eye icon
            toggleBtn.innerHTML = `
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            `;
          }
        });
        
        wrapper.appendChild(toggleBtn);
      };
      
      // Try to find password fields in sign-in form
      const signInForm = document.querySelector('amplify-sign-in');
      if (signInForm && signInForm.shadowRoot) {
        const passwordInputs = signInForm.shadowRoot.querySelectorAll('input[type="password"]');
        passwordInputs.forEach((input) => {
          const container = input.parentElement;
          if (container) {
            addToggleToField(input, container);
          }
        });
      }
      
      // Try to find password fields in sign-up form
      const signUpForm = document.querySelector('amplify-sign-up');
      if (signUpForm && signUpForm.shadowRoot) {
        const passwordInputs = signUpForm.shadowRoot.querySelectorAll('input[type="password"]');
        passwordInputs.forEach((input) => {
          const container = input.parentElement;
          if (container) {
            addToggleToField(input, container);
          }
        });
      }
      
      // Also check for password fields in amplify-password-field elements
      const passwordFields = document.querySelectorAll('amplify-password-field');
      passwordFields.forEach((field) => {
        if (field.shadowRoot) {
          const input = field.shadowRoot.querySelector('input[type="password"]');
          if (input && input.parentElement) {
            addToggleToField(input, input.parentElement);
          }
        }
      });
    }
  },
};
</script>

<style>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
@import url("https://fonts.googleapis.com/css?family=Quicksand");
#app {
  font-family: Quicksand, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}

/* Ensure v-main takes full height and has minimal padding */
.v-main {
  padding-top: 56px !important; /* Adjust based on your app bar height */
}

.v-main__wrap {
  min-height: calc(100vh - 56px);
}

/* Hide auth section completely when not needed */
.auth {
  /* margin: auto auto; */
}

.auth:empty {
  display: none;
}

amplify-authenticator {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 60vh;
}

/* Additional styles for password toggle button */
.password-toggle-btn:hover {
  opacity: 0.7;
}

.password-toggle-btn:focus {
  outline: none;
}
</style>